export default "__VITE_ASSET__CAIQRDAc__"